"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHighZoomLevel = void 0;
var _useMedia = require("./useMedia");
// Be calculated based on 1280 * 1024 resolution in 400% zoom level.
// This numbers used based on https://www.w3.org/WAI/WCAG21/Understanding/reflow.html
const ZOOM_LEVEL_BASE_WIDTH = 1280;
const ZOOM_LEVEL_BASE_HEIGHT = 1024;
const ZOOM_LEVEL = 400;
const useHighZoomLevel = function () {
  let {
    baseViewportWidth = ZOOM_LEVEL_BASE_WIDTH,
    baseViewportHeight = ZOOM_LEVEL_BASE_HEIGHT,
    level = ZOOM_LEVEL,
    checkOnlyWidth,
    checkOnlyHeight
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const maxWidth = baseViewportWidth * 100 / level;
  const maxHeight = baseViewportHeight * 100 / level;
  let query;
  if (checkOnlyWidth && !checkOnlyHeight) query = "(max-width: ".concat(maxWidth, "px)");else if (checkOnlyHeight && !checkOnlyWidth) query = "(max-height: ".concat(maxHeight, "px)");else query = "(max-width: ".concat(maxWidth, "px) and (max-height: ").concat(maxHeight, "px)");

  // defaultMatches need to be set to the false for SSR.
  // media will not be matched as default in SSR.
  const isInHighZoomLevel = (0, _useMedia.useMedia)({
    query,
    defaultMatches: false
  });
  return {
    isInHighZoomLevel
  };
};
exports.useHighZoomLevel = useHighZoomLevel;